var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "teaser",
      class: {
        isScrolledIntoView:
          _vm.isLoaded && _vm.isReflowed && _vm.isScrolledIntoView
      }
    },
    [
      _vm.posts.slice(0, _vm.teaserMaxItems).length
        ? _c(
            "div",
            {
              staticClass: "teaser-inner",
              class: { "teaser-inner-blank": !_vm.teaserHeading }
            },
            [
              _vm.teaserHeading
                ? _c("h2", { staticClass: "heading" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.teaserHeading) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "div",
                  { staticClass: "row row-eq-height" },
                  _vm._l(_vm.posts.slice(0, _vm.teaserMaxItems), function(
                    post
                  ) {
                    return _c(
                      "div",
                      { staticClass: "col col-12 col-md-6" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: _vm.wpApi.stripBaseUrl(post["link"]) }
                          },
                          [
                            _c("div", { staticClass: "item" }, [
                              _c("div", { staticClass: "item-inner" }, [
                                _c(
                                  "div",
                                  { staticClass: "item-image-container" },
                                  [
                                    post["acf"]["teaser_image_960_720"]
                                      ? _c("div", {
                                          staticClass: "item-image",
                                          style: {
                                            backgroundImage:
                                              "url(" +
                                              _vm.wpApi.stripHost(
                                                post["acf"][
                                                  "teaser_image_960_720"
                                                ]
                                              ) +
                                              ")"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-card" }, [
                                  _c(
                                    "div",
                                    { staticClass: "item-card-inner" },
                                    [
                                      _c("h4", {
                                        staticClass: "item-heading",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            post["acf"]["teaser_title"]
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        staticClass: "item-text",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            post["acf"]["teaser_copy"]
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "item-action-container" },
                                [
                                  _c("div", { staticClass: "item-action" }, [
                                    _c("div", {
                                      staticClass: "item-action-icon"
                                    })
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b2b60ea", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b2b60ea","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Teaser.vue
// module id = 588
// module chunks = 0